import * as colors from 'HubStyleTokens/colors';
import { getSLAIconColorFromStatus } from 'conversations-thread-data/tickets/public/operators';
export const getColorHashForSLAIconFromStatus = slaStatus => {
  const iconColorName = getSLAIconColorFromStatus(slaStatus);
  if (iconColorName === 'DEFAULT') return colors.EERIE;
  return colors[iconColorName];
};